import { Action } from 'redux';
import { Epic } from 'redux-observable';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import { concat as concat$ } from 'rxjs/observable/concat';
import { from as from$ } from 'rxjs/observable/from';
import {
    ACTION_INTERESTS_LOAD,
    ACTION_INTERESTS_LOAD_BY_ID,

    ACTION_INTERESTS_SAVE,

    ACTION_INTERESTS_CREATE,

    IInterestLoadAction,
    IInterestLoadByIdAction,
    IInterestLoadFailureAction,
    IInterestLoadSuccessAction,

    IInterestSaveAction,
    IInterestSaveSuccessAction,
    IInterestSaveFailureAction,

    IInterestCreateAction,
    IInterestCreateSuccessAction,
    IInterestCreateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

} from "../actions/interests";
import { interestsApi } from "../services/interest";


export const
    getInterestsEpic = (action$): Observable<IInterestLoadSuccessAction | IInterestLoadFailureAction> => {
        return action$
            .ofType(ACTION_INTERESTS_LOAD)
            .mergeMap((action: IInterestLoadAction) => {
                return interestsApi
                    .getInterests()
                    .map(response =>
                        LoadSuccess(response.interests, undefined, undefined, [], [], response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getInterestByIdEpic = (action$): Observable<IInterestLoadSuccessAction | IInterestLoadFailureAction> => {
        return action$
            .ofType(ACTION_INTERESTS_LOAD_BY_ID)
            .mergeMap((action: IInterestLoadByIdAction) => {
                return interestsApi
                    .getInterestById(action.id)
                    .map(response =>
                        LoadSuccess(response.interest, response.formState, response.formProperties, response.formRoles, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setInterestEpic = (action$): Observable<IInterestSaveSuccessAction | IInterestSaveFailureAction> => {
        return action$
            .ofType(ACTION_INTERESTS_SAVE)
            .mergeMap((action: IInterestSaveAction) => {
                return interestsApi
                    .setInterest(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.interest, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createInterestEpic = (action$): Observable<IInterestCreateSuccessAction | IInterestCreateFailureAction> => {
        return action$
            .ofType(ACTION_INTERESTS_CREATE)
            .mergeMap((action: IInterestCreateAction) => {
                return interestsApi
                    .createInterest()
                    .map(response =>
                        CreateSuccess(
                            response.interest,
                            response.formState,
                            response.formProperties,
                            response.formRoles,
                            response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    }



